<template>
  <div class="productlist">
    <div class="head">
      <h3>订单商品</h3>
    </div>
    <div>
      <div class="list">
        <ul class="pro-info">
          <li v-for="(item, index) of proInfo" :key="index">
            <div class="pro-img">
              <img :src="item.pic" />
            </div>
            <div class="right-contain">
              <div class="name">{{ item.goods_name }}</div>
              <!-- <div class="apecs">种类: {{ item.specs }}</div> -->
              <div class="price">
                <span>{{ $setInfoDecimal(item.goods_price) }} ¥</span>
                <span>X{{ item.num }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    proInfo: {
      type: Array,
      default: () => { return [] }
    }
  },
}
</script>
<style lang="scss" scoped>
.productlist {
  .head {
    padding-left: 0.2rem;
  }
  font-size: 0.32rem;
  .list {
    ul {
      border-radius: 10px;
      background: #fff;
      width: 6.7rem;
      padding: 0.2rem;
      margin: auto;
    }
  }
  .pro-info li {
    @include flexBox(space-between);
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.1rem;
  }
  .pro-img {
    width: 1.71rem;
    height: 1.71rem;
  }
  .right-contain {
    width: 4.8rem;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 1.71rem;
    font-size: 0.28rem;
    .apecs {
      color: #999999;
    }
    .name {
      overflow: hidden;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      display: -webkit-box;
      display: box;
    }
    .price {
      @include flexBox(space-between);
      span:nth-child(1) {
        color: #ff6161;
        font-weight: 800;
      }
      span:nth-child(2) {
        font-weight: 800;
      }
    }
  }
}
</style>